import { computed, Injectable, signal } from '@angular/core';
import { IAuthCurrentUser, OperatorRoleEnum } from '@pkp-g/core';

@Injectable({
  providedIn: 'root',
})
export class CurrentUserService {
  user = signal<IAuthCurrentUser | null>(null);

  hasRole = (role: OperatorRoleEnum): boolean => this.user()?.roles.includes(role) ?? false;

  isAdmin = computed(() => this.hasRole(OperatorRoleEnum.Admin));

  isOperator = computed(() => this.hasRole(OperatorRoleEnum.Operator));

  isPersonal = computed(() => this.hasRole(OperatorRoleEnum.Personal));
}
